import { useEffect, useMemo } from 'react';
import { bool } from 'prop-types';
import initializeDemo from './entrypoints/demo';
import initialize from './entrypoints/sportsbook';
const AppContainer = ({ dev = false, locale, translations, jurisdiction, environment, }) => {
    const params = useMemo(() => ({
        jurisdiction,
        environment,
        locale,
        translations,
    }), [jurisdiction, environment, locale, translations]);
    useEffect(() => {
        const removeApp = dev ? initializeDemo(params) : initialize(params);
        return () => {
            removeApp();
        };
    }, [params]);
    return null;
};
AppContainer.propTypes = {
    dev: bool,
};
export default AppContainer;
//# sourceMappingURL=index.js.map